import classNames from 'classnames';
import React, { forwardRef } from 'react';

import {
  TextArea as TextAreaUI5,
  TextAreaDomRef,
  TextAreaPropTypes,
} from '@ui5/webcomponents-react';

import styles from './TextArea.module.css';

export interface TextAreaPropTypesExtended extends TextAreaPropTypes {
  /**
   * Whether or not the textArea contains an invalid value.
   * Should be used for accessibility, but this also affects the visual look
   * of the textArea field! Use this instead of the UI5's valueState: 'Negative'
   */
  'aria-invalid'?: boolean | undefined;
}

export const TextArea = forwardRef<TextAreaDomRef, TextAreaPropTypesExtended>(
  (props, ref) => {
    const { 'aria-invalid': ariaInvalid, className, rows = 4, ...rest } = props;
    const textAreaStyles = classNames(styles.textarea, className, {
      [styles.invalid]: ariaInvalid,
    });

    return (
      <TextAreaUI5
        aria-invalid={ariaInvalid}
        className={textAreaStyles}
        ref={ref}
        rows={rows}
        {...rest}
      />
    );
  },
);
